var _mask, _path, _path2, _mask2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_1316_21383",
    maskUnits: "userSpaceOnUse",
    x: 5.74023,
    y: -4.37114e-8,
    width: 2,
    height: 12,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    x: 5.74023,
    y: -4.37114e-8,
    width: 2,
    height: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26197 -2.09054e-08L6.26197 11L6.74023 11L6.74023 0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.26197 -2.09054e-08L6.26197 11L6.74023 11L6.74023 0",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26197 11L6.06197 11L6.06197 11.2L6.26197 11.2L6.26197 11ZM6.74023 11L6.74023 11.2L6.94023 11.2L6.94023 11L6.74023 11ZM6.06197 -2.96477e-08L6.06197 11L6.46197 11L6.46197 -1.21631e-08L6.06197 -2.96477e-08ZM6.26197 11.2L6.74023 11.2L6.74023 10.8L6.26197 10.8L6.26197 11.2ZM6.94023 11L6.94023 8.74228e-09L6.54023 -8.74228e-09L6.54023 11L6.94023 11Z",
    fill: "black",
    mask: "url(#path-1-outside-1_1316_21383)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-2_1316_21383",
    maskUnits: "userSpaceOnUse",
    x: -8.74228e-8,
    y: 4.73926,
    width: 12,
    height: 2,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    x: -8.74228e-8,
    y: 4.73926,
    width: 12,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5.261L1 5.261L1 5.73926L12 5.73926"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.261L1 5.261L1 5.73926L12 5.73926",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.261L1 5.061L0.8 5.061L0.8 5.261L1 5.261ZM1 5.73926L0.8 5.73926L0.8 5.93926L1 5.93926L1 5.73926ZM12 5.061L1 5.061L1 5.461L12 5.461L12 5.061ZM0.8 5.261L0.8 5.73926L1.2 5.73926L1.2 5.261L0.8 5.261ZM1 5.93926L12 5.93926L12 5.53926L1 5.53926L1 5.93926Z",
    fill: "black",
    mask: "url(#path-3-outside-2_1316_21383)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBlack);
export default __webpack_public_path__ + "static/media/AddBlack.4f2357de6336fbbb41bfc6e7939c4f37.svg";
export { ForwardRef as ReactComponent };